import React from 'react';

export default function FighterCard({ fighter, side }) {
  if (!fighter) return null;

  const isF2 = side === 'f2';

  return (
    <div className={`fighter-header-card ${side}`}>
      <div className="fighter-header-name">{fighter.full_name}</div>
      {fighter.nickname && (
        <div className="fighter-header-nickname">"{fighter.nickname}"</div>
      )}
      <div className={`fighter-header-record ${isF2 ? 'f2' : ''}`}>
        {fighter.wins}-{fighter.losses}{fighter.draws > 0 ? `-${fighter.draws}` : ''}
      </div>
      <div className="fighter-header-meta">
        {fighter.latest_weight_class}
        {fighter.belt === 'Yes' && ' 🏆'}
      </div>
      <div className="fighter-header-meta">
        {fighter.height && `${fighter.height}" · `}
        {fighter.reach && `${fighter.reach}" reach · `}
        {fighter.stance}
      </div>
      {fighter.style && (
        <div className="style-badge">{fighter.style}</div>
      )}
    </div>
  );
}
